module.exports = __webpack_public_path__ + "img/default_product.6e3154d8.svg";